import React from 'react';
import { cn } from '../../lib/utils';

const AdminCardActions = ({ children, className }) => {
  return (
    <div className={cn('mt-3 border-t border-slate-700 bg-slate-900/40', className)}>
      <div className="flex flex-wrap gap-2 justify-between p-3 sm:justify-end">
        {children}
      </div>
    </div>
  );
};

export default AdminCardActions;
export { AdminCardActions };
